export function getVersion(): string | undefined {
    const container = document.getElementById("app");
    const version = container?.dataset.buildVersion;
    return version;
}
